import { modalWindows as EnUsModalWindows } from '../en-us/modalWindows';
import { AgResourceLanguage } from '../types';

export const modalWindows: AgResourceLanguage['modalWindows'] = {
  ...EnUsModalWindows,
  editShippingMethod: {
    titleHeader: 'Verzendmethode Bewerken',
    subtitle: 'Kies:',
    saveMethodButton: 'Verzendmethode Opslaan'
  },
  editShippingAddress: {
    bannerText: 'Het bezorgadres wordt gewijzigd vanaf de volgende zending',
    titleHeaderCreate: 'Verzendadres Aanmaken',
    subscriptionUpdate: 'Instellen als het verzendadres voor mijn abonnement',
    address2: 'Appartement, Suite, Etc. (optioneel)',
    city: 'Stad',
    usedSavedLabel: 'Gebruik opgeslagen adres',
    zip: 'Postcode',
    titleAddress: 'Adres Bewerken',
    titleHeaderEdit: 'Verzendadres Bewerken',
    last_name: 'Achternaam',
    company: 'Bedrijf (optioneel)',
    first_name: 'Voornaam',
    phone: 'Telefoon',
    province: 'Provincie',
    deleteAddressText: 'Weet je zeker dat je het opgeslagen adres wilt verwijderen?',
    selectAddress: {
      reloadMessage: 'Herlaad de pagina, alstublieft',
      noSavedAddressText: 'Je hebt momenteel geen opgeslagen adressen',
      useSavedAddressButton: 'Gebruik opgeslagen adres',
      noSavedAddressButton: 'Geen opgeslagen adressen',
      titleForSelectAddressModal: 'Selecteer Verzendadres',
      cancelButton: 'Annuleren',
      submitButton: 'Ok',
      useSelectButton: 'Gebruik geselecteerd'
    },
    massUpdate: 'Gebruik voor alle actieve abonnementen',
    deleteAddressTitle: 'Adres Verwijderen',
    updateButton: 'Bijwerken',
    address1: 'Adres',
    country: 'Land',
    cancelButton: 'Annuleren'
  },
  addPaymentMethod: {
    title: 'Betaalmethode Toevoegen',
    instructions:
      'Er wordt een e-mail verzonden naar {{email}} om je betaalmethode veilig toe te voegen. Bevestig hieronder om de e-mail te verzenden.'
  },
  editPaymentMethod: {
    title: 'Betaalmethode Bewerken',
    instructions:
      'Er wordt een e-mail verzonden naar {{email}} om je betaalmethode veilig te bewerken. Bevestig hieronder om de e-mail te verzenden.',
    shopPayInstructions: `Er wordt een e-mail naar {{email}} gestuurd om je betaalmethode veilig te bewerken in Shop Pay. Bevestig hieronder om de e-mail te verzenden. \n
    Als je de betaalmethode van Shop Pay wilt wijzigen naar een andere betaalmethode, zoals PayPal of Apple Pay, annuleer dan je abonnement door terug te gaan naar je abonnementsdetails. Na annulering, maak een nieuw abonnement aan en voer de gewenste betaalmethode in.`
  },
  paymentMethod: {
    cancelButton: 'Annuleren',
    submitButton: 'E-mail Verzenden',
    successTitle: 'Bevestigingsmail Verzonden',
    successMessage: 'Controleer binnenkort je e-mail voor een bevestiging'
  },
  cancelSubscription: {
    keepButton: 'Behoud Het',
    commentsPlaceholder: 'Beschrijf het probleem',
    cancelButton: 'Abonnement Annuleren',
    reasons:
      'Ik heb geen voordelen gemerkt,Ik ga verhuizen of reizen,Ik heb al meer dan genoeg,Ik heb een medische reden,Dit is te duur,Ik vind de smaak niet lekker,Ik wil geen abonnement,Andere reden',
    v53Reasons: 'Houd niet van de nieuwe formule,Houd niet van de nieuwe tropische smaak',
    agzCancelationReasons:
      'Ik vind de smaak van AGZ niet lekker,Ik heb geen voordelen van AGZ opgemerkt,Ik heb al meer AGZ dan ik nodig heb,Ik wil geen abonnement,Ik heb een medische reden,Dit is te duur,Ik verhuis om te reizen,Andere reden',
    commentsLabel: 'Opmerkingen',
    keepSubscriptionButton: 'Abonnement Behouden',
    text: 'Bevestig hieronder de annulering van je abonnement. Als je een reden wilt geven, ontvangen we graag je feedback zodat we de ervaring voor anderen in de toekomst kunnen verbeteren (optioneel):',
    title: 'Het spijt ons dat je gaat!'
  },
  switchProduct: {
    packName: 'Reisverpakkingen',
    modalTitle: 'Overschakelen naar {{productName}}',
    title:
      'Je volgende bestelling op {{formatNextOrderDate}} zal {{qtyModal}} doos {{switchToText}} bevatten',
    infoMessage: 'Product wordt alleen gewijzigd voor je volgende bestelling.',
    cancelButton: 'Annuleren',
    confirmButton: 'Bevestigen',
    pouchName: 'Verpakkingen',
    quantityText: 'Aantal {{switchToText}} om te wisselen:',
    description: 'Je kunt het aantal van je {{switchToText}} wijzigen op de abonnementbeheerpagina.'
  },
  switchFromFreeShipping: {
    text: 'Je huidige gratis verzendingsplan vereist een 3-maandenvoorraad van AG1 Pouch die elke 90 dagen wordt verzonden. Door het product te wijzigen in Reisverpakkingen, wordt de prijs teruggezet naar €89 per 30 stuks van Reisverpakkingen en een verzendkosten van €9 per bestelling.'
  },
  skipShipment: {
    textConfirm: 'De volgende besteldatum wordt gewijzigd naar {{date}}',
    skipButton: 'Annuleren',
    questionConfirm: 'Weet je zeker dat je de volgende verzending wilt overslaan?',
    continueButton: 'Doorgaan',
    headConfirm: 'Verzending Overslaan'
  },
  acceptAddressValidation: {
    title: 'Bevestig Je Adres',
    continueButton: 'Opslaan & Doorgaan',
    enteredTitle: 'Ingevoerd Adres',
    editButton: 'Adres Bewerken',
    suggestedTitle: 'Voorgesteld Adres',
    text: 'We konden het exacte adres dat je hebt ingevoerd niet verifiëren. Controleer of het correct is of breng indien nodig wijzigingen aan.'
  },
  shopAlert: {
    deleteButtonTitle: 'Doorgaan',
    cancelButtonTitle: 'Annuleren',
    makeGiftCartButtonTitle: 'Als een Cadeau',
    subToGift: {
      headerTitle: 'Voordat je een abonnement toevoegt',
      content:
        'Cadeaubestellingen kunnen alleen producten bevatten die eenmalig worden verzonden. Door een abonnement aan je winkelwagen toe te voegen, worden cadeauproducten verwijderd.'
    },
    giftToSub: {
      headerTitle: 'Voordat je een cadeau toevoegt',
      content:
        'Abonnementbestellingen kunnen niet met een cadeaubericht worden verzonden. Door een cadeau aan je winkelwagen toe te voegen, worden abonnementproducten verwijderd.'
    },
    giftToOtp: {
      headerTitle: 'Wil je de hele bestelling als cadeau maken?',
      content:
        'Je hebt al eenmalige aankoopproducten in je winkelwagen. Wil je de hele bestelling als cadeau maken?'
    }
  },
  addProductFromSlider: {
    toastNextOrder: 'Product toegevoegd aan de volgende bestelling van ',
    toastSubscription: 'Product toegevoegd aan {{name}}',
    toastSeveralSubscription: 'Product toegevoegd aan',
    severalSubscriptions: 'abonnementen',
    toastToAllSubscription: 'Product toegevoegd aan alle abonnementen',
    toastToAllNextOrder: 'Product toegevoegd aan de volgende bestelling van alle abonnementen',
    titleSubscription: 'Product Toevoegen Aan Abonnement',
    titleNextOrder: 'Product Toevoegen aan Volgende Bestelling',
    checkbox: 'Toevoegen aan alle actieve abonnementen',
    text: 'Selecteer het abonnement waaraan je het product wilt toevoegen.',
    addProductButton: 'Product Toevoegen'
  },
  cart: {
    subscriptionTitle: 'Abonnement',
    title: 'Je Winkelwagen',
    checkoutButtonLabel: 'Afrekenen',
    summary: {
      taxEstimatedLabel: 'Geschatte Belasting',
      taxLabel: 'Belasting',
      totalLabel: 'Totaal',
      taxNotReady: '---',
      shippingLabel: 'Verzending',
      discountLabel: 'Je korting',
      freePrice: 'Gratis',
      subtotalLabel: 'Subtotaal'
    },
    emptyState: {
      oneTimeProductsTitle: 'Favorieten van Leden',
      addOneTimeProductButton: 'Toevoegen aan Winkelwagen',
      label: 'Voeg artikelen toe aan je winkelwagen'
    },
    emptyStateLabel: 'Voeg artikelen toe aan je winkelwagen',
    frequencyLabel: 'Verzonden elke 30 dagen',
    promoCode: {
      promoCTA: 'Heb je een promotiecode?',
      promoError: 'Kortingscode is ongeldig',
      promoInputLabel: 'Promotiecode',
      promoButtonLabel: 'Toepassen'
    }
  },
  changeOrderDate: {
    title: 'Selecteer Besteldatum',
    confirmButton: 'Bevestigen',
    nextOrderDateSuccessText: 'Je volgende besteldatum is {{date}}.',
    nextOrderDateChangeText:
      'Je volgende besteldatum voor dit abonnement wordt verplaatst naar {{date}} ',
    description: 'Je kunt de datum van je volgende bestelling wijzigen',
    newDateChangeText: 'De volgende besteldatum is',
    newDateSuccessText: 'De volgende besteldatum is gewijzigd naar {{date}} '
  },
  shipNow: {
    shipNowButton: 'Bestelling Bevestigen',
    subtitle: 'Bestelling succesvol geplaatst',
    description:
      'Deze bestelling wordt naar verwachting binnen 24 uur M-V na betaling verzonden. Houd rekening met maximaal 48 uur in het weekend en op feestdagen. Je volgende bestelling wordt geplaatst over {{shipInterval}} op {{date}}',
    title: 'Verzonden Volgende Bestelling Nu',
    confirm:
      'Wanneer je hieronder bevestigt, wordt je bestelling binnen 1 werkdag verwerkt. Houd rekening met maximaal 48 uur in het weekend en op feestdagen.',
    preparing: 'Voorbereiden',
    preparingDescription: 'Je hebt een huidige bestelling die naar verwachting verzonden wordt',
    shipped: 'Verzonden',
    shippedDescription: 'Je hebt een huidige bestelling die verzonden is',
    delivered: 'Geleverd',
    deliveredDescription: 'Je laatste bestelling is geleverd',
    shipNext: 'Volgende bestelling nu verzenden:',
    nextOrder: 'Volgende bestelling:',
    followedBy: 'Gevolgd door:'
  },
  editFrequency: {
    titleView: 'Verzendfrequentie Bewerken',
    titleDatepicker: 'Wijzig Volgende Besteldatum',
    day: 'Dag',
    infoMessage: 'Verzendfrequentie is gewijzigd naar {{date}}.',
    shippingFrequency: 'Verzendfrequentie',
    item: 'Elke',
    nextOrderButton: 'Volgende Besteldatum',
    nextOrderLink: 'Wijzig volgende besteldatum',
    nextOrder: 'Volgende bestelling:',
    followedBy: 'Gevolgd door:',
    description: 'Wijzigingen gaan in vanaf je volgende besteldatum.',
    followingText: 'gevolgd door',
    ribbonMessage:
      'Deze wijziging is alleen van toepassing op de bestellingen <bold>{{followingText}}</bold> na je volgende besteldatum.',
    extraInfo:
      'Wanneer je hieronder bevestigt, wordt je vandaag in rekening gebracht en de bestelling wordt binnen 1 werkdag verzonden. Houd rekening met maximaal 48 uur in het weekend en op feestdagen.',
    saveButton: 'Wijzigingen Opslaan',
    confirmButton: 'Bevestigen'
  },
  acceptChanges: {
    text: 'Het bijwerken van je abonnementsgegevens zal je volgende bestelling resetten en "eenmalige" artikelen verwijderen.',
    title: 'Voordat Je Je Abonnement Wijzigt',
    continueButton: 'Doorgaan',
    cancelButton: 'Annuleren'
  },
  acceptFreeShippingChanges: {
    text: 'Je huidige gratis verzendingsplan vereist een voorraad van 3 maanden product, verzonden elke 90 dagen. Door de hoeveelheid te wijzigen, wordt de prijs teruggezet naar €79 per zak en verzendkosten van €9 per bestelling.',
    title: 'Voordat Je Je Abonnement Wijzigt',
    continueButton: 'Doorgaan',
    cancelButton: 'Annuleren',
    successMessage: 'Je abonnement is nu €79 per zak en heeft €9 verzendkosten'
  },
  activateSubscription: {
    successTitle: 'Je abonnement {{name}} is actief en beschikbaar om te beheren.',
    errorMessage: 'Kan besteldatum niet wijzigen',
    activateButton: 'Abonnement Activeren',
    title: 'Abonnement Heractiveren',
    infoMessage:
      'Je kunt de datum van je volgende bestelling wijzigen voordat je abonnement wordt geactiveerd',
    successDescription: 'De volgende besteldag is {{date}}.'
  },
  addProductFromModal: {
    noteTitle: 'How to swap from AG1 Pouch to AG1 30 Ct Travel Packs',
    noteSubtitle:
      'To swap between Pouch and 30 Ct Travel Packs, add the desired product to your subscription by selecting “Add to Subscription”. Once added, remove the other product from your subscription by selecting the trash can icon on your Subscription Details page.',
    addToOrder: 'Product Toevoegen aan Bestelling',
    addToSubscription: 'Toevoegen aan Abonnement',
    addToNextOrder: 'Toevoegen aan Volgende Bestelling',
    addedToNextOrder: 'Toegevoegd aan Volgende Bestelling',
    addedToSubscription: 'Toegevoegd aan Abonnement'
  }
};
